import { Anchor, Lock, ImageOff } from 'lucide-react';
import { STAGES, STATUS_META, fullImg } from './constants';

/** V15.21 — Zone 2a : rail des 4 étapes avec la vignette de référence de chaque étape. */
export const PipelineStepRail = ({ stages, activeStage, onSelect }) => (
  <div className="grid grid-cols-4 gap-2" role="tablist" aria-label="Étapes du lot" data-testid="pipeline-step-rail">
    {STAGES.map((s) => {
      const e = stages?.[s.id] || {};
      const st = STATUS_META[e.status || 'todo'];
      const active = activeStage === s.id;
      const locked = e.base && !e.base.ready;
      const latest = e.latest?.find((j) => j.is_validated && j.image_url) || e.latest?.find((j) => j.image_url);
      const thumb = e.reference?.image_url || latest?.image_url || null;
      return (
        <button key={s.id} type="button" role="tab" aria-selected={active} onClick={() => onSelect(s.id)}
                className="text-left rounded-xl overflow-hidden transition-all duration-200"
                style={{ border: `1px solid ${active ? 'var(--c-gold)' : 'var(--c-border)'}`, background: active ? 'rgba(217,160,91,0.08)' : 'rgba(255,255,255,0.025)',
                         boxShadow: active ? '0 0 14px rgba(217,160,91,0.18)' : 'none' }}
                data-testid={`stepper-step-${s.n}-${s.id}`}>
          <div className="relative aspect-[16/10] flex items-center justify-center" style={{ background: '#ffffff' }}>
            {thumb ? <img src={fullImg(thumb)} alt="" className="w-full h-full object-contain" />
              : <div className="flex flex-col items-center gap-1 text-[10.5px]" style={{ color: '#9CA3AF' }}>{locked ? <Lock className="w-4 h-4" /> : <ImageOff className="w-4 h-4" />}{locked ? 'Étape précédente requise' : 'Aucun rendu'}</div>}
            {!e.reference?.job_id && latest && s.id !== 'final' && (
              <span className="absolute top-1.5 left-1.5 text-[9.5px] px-1.5 py-0.5 rounded-full font-semibold" style={{ background: 'rgba(16,17,20,0.85)', color: '#FDE68A' }}>Dernier rendu · non ancré</span>
            )}
            {e.reference?.job_id && (
              <span className="absolute top-1.5 left-1.5 inline-flex items-center gap-1 text-[9.5px] px-1.5 py-0.5 rounded-full font-semibold" style={{ background: 'rgba(16,17,20,0.85)', color: '#F5C77E' }}>
                <Anchor className="w-2.5 h-2.5" /> Référence
              </span>
            )}
            {typeof e.reference?.fidelity_score === 'number' && (
              <span className="absolute top-1.5 right-1.5 text-[9.5px] px-1.5 py-0.5 rounded-full font-mono" style={{ background: 'rgba(16,17,20,0.85)', color: '#86EFAC' }}>Plan {e.reference.fidelity_score} %</span>
            )}
          </div>
          <div className="px-2.5 py-2">
            <div className="flex items-center justify-between gap-1">
              <span className="text-[12px] font-semibold" style={{ color: active ? 'var(--c-gold)' : 'var(--c-text)' }}><span className="font-mono mr-1">{s.n}</span>{s.label}</span>
              <span className="text-[9.5px] whitespace-nowrap" style={{ color: 'var(--c-text-faint)' }}>{s.engine}</span>
            </div>
            <span className="mt-1 inline-flex text-[10px] px-1.5 py-0.5 rounded-full" style={{ background: st.bg, color: st.color }} data-testid={`stepper-status-${s.id}`}>
              {s.optional && (e.status || 'todo') === 'todo' ? 'Optionnel — livrable dès l’étape 3' : st.label}
            </span>
            {e.counts?.total > 0 && <span className="ml-1.5 text-[10px] font-mono" style={{ color: 'var(--c-text-faint)' }}>{e.counts.completed}/{e.counts.total} rendus</span>}
          </div>
        </button>
      );
    })}
  </div>
);

export default PipelineStepRail;
